import LogoSlot from "./LogoSlot";
import { footer } from "../data/content";
import { LOGO_FULL_SRC } from "../constants/brand";

export default function Footer() {
  return (
    <footer className="border-t border-site-hairline bg-site-surface px-6 py-16">
      <div className="mx-auto max-w-site">
        <div className="mb-12 grid gap-12 md:grid-cols-4">
          {/* Brand */}
          <div className="md:col-span-2">
            <LogoSlot
              src={LOGO_FULL_SRC}
              alt="Omnyx"
              className="mb-6 h-8 w-auto"
              placeholderClassName="h-8 w-28 text-site-ink"
            />
            <p className="max-w-sm text-site-muted">{footer.tagline}</p>
          </div>

          {/* Platforms */}
          <div>
            <h4 className="mb-4 font-heading text-sm font-bold text-site-ink">
              Platforms
            </h4>
            <ul className="space-y-3">
              {footer.platforms.map((item) => (
                <li key={item.name}>
                  {item.href ? (
                    <a
                      href={item.href}
                      target={item.external ? "_blank" : undefined}
                      rel={item.external ? "noopener noreferrer" : undefined}
                      className="rounded text-site-muted transition-colors hover:text-omnyx-teal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-omnyx-teal"
                    >
                      {item.name}
                    </a>
                  ) : (
                    <span className="text-site-muted/70">{item.name}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="mb-4 font-heading text-sm font-bold text-site-ink">
              Company
            </h4>
            <ul className="space-y-3">
              {footer.company.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="rounded text-site-muted transition-colors hover:text-omnyx-teal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-omnyx-teal"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="mb-4 font-heading text-sm font-bold text-site-ink">
              Legal
            </h4>
            <ul className="space-y-3">
              {footer.legal.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    className="rounded text-site-muted transition-colors hover:text-omnyx-teal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-omnyx-teal"
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-site-hairline pt-8">
          <p className="text-center text-sm text-site-muted">{footer.copyright}</p>
        </div>
      </div>
    </footer>
  );
}
